import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=2440a46d&scoped=true&"
import script from "./Domains.vue?vue&type=script&lang=js&"
export * from "./Domains.vue?vue&type=script&lang=js&"
import style1 from "./Domains.vue?vue&type=style&index=1&id=2440a46d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440a46d",
  null
  
)

export default component.exports
import {QPage,QTable,QInput,QIcon,QBtn,QMenu,QList,QItem,QItemSection,QTr,QTd,QCheckbox,QBadge,QDialog,QCard,QCardSection,QCardActions,QInnerLoading,QSpinnerIos,ClosePopup} from 'quasar'
component.options.components = Object.assign({QPage,QTable,QInput,QIcon,QBtn,QMenu,QList,QItem,QItemSection,QTr,QTd,QCheckbox,QBadge,QDialog,QCard,QCardSection,QCardActions,QInnerLoading,QSpinnerIos}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
